{
  "el": {
    "form": {
      "actions": {
        "cancel": "Ακύρωση",
        "clear": "Εκκαθάριση",
        "closeFullPage": "Κλείσιμο πλήρους σελίδας",
        "copyText": "Κάνε κλικ για αντιγραφή του κειμένου",
        "create_and_attach_phase": "Δημιουργία και σύνδεση με φάση",
        "create_and_send": "Δημιουργία και αποστολή",
        "create_and_send_to_customer": "Δημιουργία και αποστολή στον πελάτη",
        "create_and_share": "Δημιουργία και κοινοποίηση στον πελάτη",
        "create_and_share_partners_only": "Δημιουργία και κοινοποίηση στους συνεργάτες",
        "create_and_share_with_partners": "Δημιουργία και κοινοποίηση σε πελάτη και συνεργάτες",
        "next": "Επόμενο",
        "only_create": "Μόνο δημιουργία",
        "openFullPage": "Άνοιγμα σε πλήρη σελίδα",
        "save": "Αποθήκευση",
        "saveChanges": "Αποθήκευση αλλαγών",
        "save_as_draft": "Αποθήκευση ως πρόχειρη",
        "search": "Αναζήτηση...",
        "send": "Αποστολή",
        "send_and_create_another": "Αποστολή και δημιουργία νέου",
        "send_to_customer": "Αποστολή στον πελάτη",
        "share_with_customer": "Κοινοποίηση στον πελάτη",
        "submit": "Υποβολή",
        "submit_and_create_another": "Υποβολή και δημιουργία νέου"
      },
      "back": "Προηγούμενο βήμα",
      "labels": {
        "columns": "Στήλες",
        "from": "Από",
        "no_results": "Κανένα αποτέλεσμα",
        "optional": "(προαιρετικό)",
        "to": "Έως"
      },
      "notifications": {
        "textHasBeenCopied": "Το κείμενο αντιγράφηκε"
      },
      "password": "Κωδικός πρόσβασης",
      "send_moment": {
        "attach_failed": "Δημιουργήθηκε, αλλά δεν συνδέθηκε με τη φάση. Σύνδεσέ το ξανά στη ροή εργασιών.",
        "concept_description": "Κανείς δεν βλέπει τίποτα. Το στέλνεις εσύ αργότερα ή το συνδέεις τελικά με μια φάση.",
        "concept_title": "Αποθήκευση ως πρόχειρη",
        "item_decision": "αυτή την απόφαση",
        "item_survey": "αυτό το ερωτηματολόγιο",
        "item_todo": "αυτή την εργασία",
        "now_description_decision": "Οι πελάτες των επιλεγμένων ακινήτων λαμβάνουν την απόφαση αμέσως, με ειδοποίηση.",
        "now_description_survey": "Οι πελάτες των επιλεγμένων ακινήτων λαμβάνουν το ερωτηματολόγιο αμέσως, με ειδοποίηση.",
        "now_description_todo": "Οι υπεύθυνοι των επιλεγμένων ακινήτων λαμβάνουν την εργασία αμέσως, με ειδοποίηση.",
        "now_title": "Αποστολή τώρα",
        "phase_description": "Αποστέλλεται αυτόματα για κάθε ακίνητο μόλις αυτό φτάσει στη φάση.",
        "phase_label": "Φάση",
        "phase_title": "Σύνδεση με φάση",
        "title": "Πότε θα δει ο πελάτης {item};",
        "workflow_help": "Τι είναι η ροή εργασιών;",
        "workflow_help_more": "Διάβασε περισσότερα",
        "workflow_help_text": "Η ροή εργασιών είναι οι φάσεις από τις οποίες περνά κάθε ακίνητο. Αν συνδέσεις κάτι με μια φάση, ο πελάτης το βλέπει αυτόματα μόλις το ακίνητό του φτάσει σε αυτή τη φάση."
      },
      "shortcuts": {
        "save_mac": "⌘ + Enter για αποθήκευση",
        "save_windows": "Ctrl + Enter για αποθήκευση",
        "send_mac": "⌘ + Enter για αποστολή",
        "send_windows": "Ctrl + Enter για αποστολή"
      },
      "steps": "Βήμα {count} από {total}",
      "writeEmployeeNameReject": "Γράψε <i><b>{employeeName}</b></i> για να συνεχίσεις."
    }
  }
}
